// import React, { useContext, useState } from 'react'
// import loginIcons from '../assest/signin.gif'
// import { FaEye } from "react-icons/fa";
// import { FaEyeSlash } from "react-icons/fa";
// import { Link, useNavigate } from 'react-router-dom';
// import SummaryApi from '../common';
// import { toast } from 'react-toastify';
// import Context from '../context';
// import { useDispatch } from 'react-redux';
// import { setUserDetails } from '../store/userSlice';
// import mergeCart from '../helpers/mergeCart';

// const Login = () => {
//     const [showPassword,setShowPassword] = useState(false)
//     const dispatch = useDispatch();
//     const [data,setData] = useState({
//         email : "",
//         password : ""
//     })
//     const navigate = useNavigate()
//     const { fetchUserDetails, fetchUserAddToCart } = useContext(Context)

//     const handleOnChange = (e) =>{
//         const { name , value } = e.target

//         setData((preve)=>{
//             return{
//                 ...preve,
//                 [name] : value
//             }
//         })
//     }


//   const handleSubmit = async(e) =>{
//     e.preventDefault()

//     const dataResponse = await fetch(SummaryApi.signIn.url,{
//         method : SummaryApi.signIn.method,
//         credentials : 'include',
//         headers : {
//             "content-type" : "application/json"
//         },
//         body : JSON.stringify(data)
//     })

//     const dataApi = await dataResponse.json()

//     if(dataApi.success){
//         toast.success(dataApi.message)

//         dispatch(setUserDetails(dataApi.data))   // 🔥 THIS FIX

//         fetchUserAddToCart()  // cart count

//         navigate('/')
//     }

//   if(dataApi.success){
//     toast.success(dataApi.message)

//     // 🔥 Update Redux
//     dispatch(setUserDetails(dataApi.data))

//     // Optional: cart count fetch
//     fetchUserAddToCart()

//     navigate('/')
// }
// }

//     console.log("data login",data)
    
//   return (
//     <section id='login'>
//         <div className='mx-auto container p-4'>

//             <div className='bg-white p-5 w-full max-w-sm mx-auto'>
//                     <div className='w-20 h-20 mx-auto'>
//                         <img src={loginIcons} alt='login icons'/>
//                     </div>

//                     <form className='pt-6 flex flex-col gap-2' onSubmit={handleSubmit}>
//                         <div className='grid'>
//                             <label>Email : </label>
//                             <div className='bg-slate-100 p-2'>
//                                 <input 
//                                     type='email' 
//                                     placeholder='enter email' 
//                                     name='email'
//                                     value={data.email}
//                                     onChange={handleOnChange}
//                                     className='w-full h-full outline-none bg-transparent'/>
//                             </div>
//                         </div>

//                         <div>
//                             <label>Password : </label>
//                             <div className='bg-slate-100 p-2 flex'>
//                                 <input 
//                                     type={showPassword ? "text" : "password"} 
//                                     placeholder='enter password'
//                                     value={data.password}
//                                     name='password' 
//                                     onChange={handleOnChange}
//                                     className='w-full h-full outline-none bg-transparent'/>
//                                 <div className='cursor-pointer text-xl' onClick={()=>setShowPassword((preve)=>!preve)}>
//                                     <span>
//                                         {
//                                             showPassword ? (
//                                                 <FaEyeSlash/>
//                                             )
//                                             :
//                                             (
//                                                 <FaEye/>
//                                             )
//                                         }
//                                     </span>
//                                 </div>
//                             </div>
//                             <Link to={'/forgot-password'} className='block w-fit ml-auto hover:underline hover:text-red-600'>
//                                 Forgot password ?
//                             </Link>
//                         </div>

//                         <button className='bg-red-600 hover:bg-red-700 text-white px-6 py-2 w-full max-w-[150px] rounded-full hover:scale-110 transition-all mx-auto block mt-6'>Login</button>

//                     </form>

//                     <p className='my-5'>Don't have account ? <Link to={"/sign-up"} className=' text-red-600 hover:text-red-700 hover:underline'>Sign up</Link></p>
//             </div>


//         </div>
//     </section>
//   )
// }

// export default Login
// import React, { useContext, useState } from 'react'
// import loginIcons from '../assest/signin.gif'
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { Link, useNavigate } from 'react-router-dom';
// import SummaryApi from '../common';
// import { toast } from 'react-toastify';
// import Context from '../context';
// import { useDispatch } from 'react-redux';
// import { setUserDetails } from '../store/userSlice';

// const Login = () => {
//   const [showPassword, setShowPassword] = useState(false)
//   const [showSignupPopup, setShowSignupPopup] = useState(false)

//   const dispatch = useDispatch();

//   const [data, setData] = useState({
//     email: "",
//     password: ""
//   })

//   const navigate = useNavigate()
//   const { fetchUserAddToCart } = useContext(Context)

//   const handleOnChange = (e) => {
//     const { name, value } = e.target

//     setData((preve) => ({
//       ...preve,
//       [name]: value
//     }))
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     const dataResponse = await fetch(SummaryApi.signIn.url, {
//       method: SummaryApi.signIn.method,
//       credentials: 'include',
//       headers: {
//         "content-type": "application/json"
//       },
//       body: JSON.stringify(data)
//     })

//     const dataApi = await dataResponse.json()

//     if (dataApi.success) {
//       toast.success(dataApi.message)

//       dispatch(setUserDetails(dataApi.data))
//       fetchUserAddToCart()

//       navigate('/')
//     } else {

//       // 🔥 WRONG PASSWORD
//       if (dataApi.message === "Invalid password") {
//         toast.error("Wrong Password ❌")
//       }

//       // 🔥 ACCOUNT NOT FOUND
//       else if (dataApi.message === "User not found") {
//         setShowSignupPopup(true)
//       }

//       // 🔥 DEFAULT
//       else {
//         toast.error(dataApi.message || "Something went wrong")
//       }
//     }
//   }

//   return (
//     <section className='min-h-screen flex items-center justify-center bg-gray-100 px-4'>

//       <div className='bg-white p-6 rounded-xl shadow-xl w-full max-w-md animate-fade'>

//         {/* ICON */}
//         <div className='w-20 h-20 mx-auto mb-4'>
//           <img src={loginIcons} alt='login' />
//         </div>

//         {/* FORM */}
//         <form className='flex flex-col gap-3' onSubmit={handleSubmit}>

//           <div>
//             <label>Email</label>
//             <input
//               type='email'
//               placeholder='Enter email'
//               name='email'
//               value={data.email}
//               onChange={handleOnChange}
//               className='w-full p-2 border rounded bg-gray-100 outline-none'
//             />
//           </div>

//           <div>
//             <label>Password</label>

//             <div className='flex items-center border rounded bg-gray-100 p-2'>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 placeholder='Enter password'
//                 name='password'
//                 value={data.password}
//                 onChange={handleOnChange}
//                 className='w-full bg-transparent outline-none'
//               />

//               <span
//                 className='cursor-pointer text-xl'
//                 onClick={() => setShowPassword(!showPassword)}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </span>
//             </div>

//             <Link to={'/forgot-password'} className='text-sm text-red-600 hover:underline'>
//               Forgot password?
//             </Link>
//           </div>

//           <button className='bg-black text-white py-2 rounded hover:opacity-90 transition-all mt-3'>
//             Login
//           </button>

//         </form>

//         {/* SIGNUP LINK */}
//         <p className='text-center mt-4'>
//           Don’t have account?{" "}
//           <Link to={"/sign-up"} className='text-red-600 hover:underline'>
//             Sign up
//           </Link>
//         </p>
//       </div>

//       {/* 🔥 SIGNUP POPUP */}
//       {showSignupPopup && (
//         <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50'>
//           <div className='bg-white p-6 rounded-xl text-center w-[90%] max-w-sm animate-fade'>

//             <h2 className='text-lg font-bold mb-2'>Account Not Found</h2>
//             <p className='text-gray-500 mb-4'>
//               Please create an account first
//             </p>

//             <button
//               onClick={() => navigate("/sign-up")}
//               className='bg-black text-white px-4 py-2 rounded'
//             >
//               Sign Up
//             </button>

//             <button
//               onClick={() => setShowSignupPopup(false)}
//               className='block mt-3 text-sm text-gray-500'
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}

//     </section>
//   )
// }

// export default Login
import React, { useContext, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import SummaryApi from "../common";
import { toast } from "react-toastify";
import Context from "../context";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../store/userSlice";
import { motion } from "framer-motion";

const Login = () => {

  const [showPassword, setShowPassword] = useState(false);

  const [data, setData] = useState({
    email: "",
    password: ""
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { fetchUserAddToCart } = useContext(Context);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch(SummaryApi.signIn.url, {
      method: SummaryApi.signIn.method,
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    });

    const result = await res.json();

    if (result.success) {
      toast.success("Login Success ✅");
      dispatch(setUserDetails(result.data));
      fetchUserAddToCart();
      navigate("/");
    } else {
      toast.error(result.message);
    }
  };

  return (
    // <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1e1b4b] via-[#6d28d9] to-[#9333ea] px-4">

    //   <div className="w-full max-w-4xl bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row">

    //     {/* 🔥 LEFT FORM */}
    //     <motion.div
    //       initial={{ x: -50, opacity: 0 }}
    //       animate={{ x: 0, opacity: 1 }}
    //       className="w-full md:w-1/2 p-8 flex items-center justify-center"
    //     >

    //       <form onSubmit={handleSubmit} className="w-full max-w-sm">

    //         <h2 className="text-2xl font-bold mb-6 text-center">
    //           Log in
    //         </h2>

    //         {/* EMAIL */}
    //         <input
    //           type="email"
    //           name="email"
    //           placeholder="Enter your email"
    //           value={data.email}
    //           onChange={handleChange}
    //           className="w-full p-3 mb-4 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
    //         />

    //         {/* PASSWORD */}
    //         <div className="flex items-center border rounded-lg px-3 mb-2">
    //           <input
    //             type={showPassword ? "text" : "password"}
    //             name="password"
    //             placeholder="Enter password"
    //             value={data.password}
    //             onChange={handleChange}
    //             className="w-full p-3 outline-none"
    //           />
    //           <span
    //             className="cursor-pointer"
    //             onClick={() => setShowPassword(!showPassword)}
    //           >
    //             {showPassword ? <FaEyeSlash /> : <FaEye />}
    //           </span>
    //         </div>

    //         <div className="text-right text-sm mb-4">
    //           <Link to="/forgot-password" className="text-purple-600 hover:underline">
    //             Forgot password?
    //           </Link>
    //         </div>

    //         {/* BUTTON */}
    //         <button className="w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 transition">
    //           Login
    //         </button>

    //         {/* MOBILE SIGNUP */}
    //         <p className="text-center mt-4 text-sm md:hidden">
    //           Don’t have an account?{" "}
    //           <Link to="/sign-up" className="text-purple-600 font-medium">
    //             Sign up
    //           </Link>
    //         </p>

    //       </form>

    //     </motion.div>

    //     {/* 🔥 RIGHT PANEL */}
    //     <motion.div
    //       initial={{ x: 50, opacity: 0 }}
    //       animate={{ x: 0, opacity: 1 }}
    //       className="hidden md:flex w-1/2 bg-gradient-to-br from-gray-600 to-gary-100 text-white flex-col justify-center items-center p-8"
    //     >

    //       <h2 className="text-3xl font-bold mb-3">
    //         Welcome Back!
    //       </h2>

    //       <p className="text-sm mb-6 text-center">
    //         Don't have an account? Create one now
    //       </p>

    //       <Link
    //         to="/sign-up"
    //         className="border px-6 py-2 rounded-full hover:bg-white hover:text-purple-600 transition"
    //       >
    //         Sign Up
    //       </Link>

    //     </motion.div>

    //   </div>

    // </section>
    <section
  className="min-h-screen flex items-center justify-center px-4 py-10 relative"
>
  {/* 🌄 BACKGROUND IMAGE */}
  <div
    className="absolute inset-0 bg-cover bg-center"
    style={{
      backgroundImage:
        "url('https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1920&q=80')",
    }}
  />

  {/* 🌑 DARK OVERLAY */}
  <div className="absolute inset-0 bg-black/50"></div>

  {/* 🧊 MAIN CARD */}
  <div className="relative z-10 w-full max-w-4xl 
  backdrop-blur-xl bg-white/10 border border-white/30 
  rounded-3xl shadow-2xl overflow-hidden 
  flex flex-col md:flex-row">

    {/* 🔥 LEFT FORM */}
    <motion.div
      initial={{ x: -50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      className="w-full md:w-1/2 p-6 sm:p-8 flex items-center justify-center"
    >

      <form onSubmit={handleSubmit} className="w-full max-w-sm text-white">

        <h2 className="text-2xl sm:text-3xl font-semibold mb-6 text-center">
          Login
        </h2>

        {/* EMAIL */}
        <input
          type="email"
          name="email"
          placeholder="Enter your email"
          value={data.email}
          onChange={handleChange}
          className="w-full p-3 mb-4 bg-white/20 border border-white/30 
          rounded-xl outline-none placeholder-white/70"
        />

        {/* PASSWORD */}
        <div className="flex items-center bg-white/20 border border-white/30 
        rounded-xl px-3 mb-3">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Enter password"
            value={data.password}
            onChange={handleChange}
            className="w-full p-3 outline-none bg-transparent placeholder-white/70"
          />
          <span
            className="cursor-pointer text-white/80 hover:text-white"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {/* OPTIONS */}
        <div className="flex justify-between text-sm mb-5 text-white/80">
          <label className="flex items-center gap-1">
            <input type="checkbox" className="accent-white" />
            Remember me
          </label>

          <Link to="/forgot-password" className="hover:underline">
            Forgot?
          </Link>
        </div>

        {/* BUTTON */}
        <button
          type="submit"
          className="w-full bg-white text-black py-3 rounded-xl 
          font-medium hover:bg-gray-200 transition"
        >
          Login
        </button>

        {/* MOBILE SIGNUP */}
        <p className="text-center mt-5 text-sm md:hidden text-white/80">
          Don’t have an account?{" "}
          <Link to="/sign-up" className="underline">
            Sign up
          </Link>
        </p>

      </form>

    </motion.div>

    {/* 🔥 RIGHT SIDE */}
    <motion.div
      initial={{ x: 50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      className="hidden md:flex w-1/2 
      flex-col justify-center items-center p-8 text-white"
    >

      <h2 className="text-3xl font-bold mb-3">
        Welcome Back!
      </h2>

      <p className="text-sm mb-6 text-center text-white/80">
        Create account to explore more
      </p>

      <Link
        to="/sign-up"
        className="border border-white px-6 py-2 rounded-full 
        hover:bg-white hover:text-black transition"
      >
        Sign Up
      </Link>

    </motion.div>

  </div>
</section>
  );
};

export default Login;